import { Rocket, Dices, CircleDot, Bomb, Flame, Gem } from "lucide-react";

export const GAMES = [
  {
    slug: "crash",
    name: "Crash",
    icon: Rocket,
    tags: ["hot", "originals"],
    badge: "Hot",
    tagline: "Cash out before the collapse.",
    accent: "#00F0FF",
    image: "https://images.unsplash.com/photo-1702851512287-0ae42afe7a02?w=600&q=80",
    rtp: 99,
  },
  {
    slug: "dice",
    name: "Dice",
    icon: Dices,
    tags: ["hot", "originals"],
    badge: "Classic",
    tagline: "Pick your edge, roll the fate.",
    accent: "#FFC107",
    image: "https://images.pexels.com/photos/979722/pexels-photo-979722.jpeg?auto=compress&cs=tinysrgb&w=600",
    rtp: 99,
  },
  {
    slug: "plinko",
    name: "Plinko",
    icon: CircleDot,
    tags: ["originals"],
    badge: "Chaos",
    tagline: "Gravity decides the fortune.",
    accent: "#00E676",
    image: "https://images.unsplash.com/photo-1709626011485-6fe000ea2dbc?w=600&q=80",
    rtp: 99,
  },
  {
    slug: "mines",
    name: "Mines",
    icon: Bomb,
    tags: ["hot", "originals"],
    badge: "Strategy",
    tagline: "Reveal the vault, dodge the blast.",
    accent: "#FF3366",
    image: "https://images.unsplash.com/photo-1622737133809-d95047b9e673?w=600&q=80",
    rtp: 99,
  },
  {
    slug: "slots",
    name: "Slots",
    icon: Flame,
    tags: ["slots", "originals"],
    badge: "Luck",
    tagline: "Three symbols, one jackpot.",
    accent: "#D97706",
    image: "https://images.pexels.com/photos/31379653/pexels-photo-31379653.jpeg?auto=compress&cs=tinysrgb&w=600",
    rtp: 99,
  },
  {
    slug: "megaslots",
    name: "Mega Slots",
    icon: Gem,
    tags: ["slots", "new", "originals"],
    badge: "New",
    tagline: "Five reels, wilds, scatters, a 1000× seven.",
    accent: "#FF3366",
    image: "https://images.unsplash.com/photo-1518895312237-a9e23508077d?w=600&q=80",
    rtp: 98.8,
  },
];

export const gameBySlug = (slug) => GAMES.find((g) => g.slug === slug);
